import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import type { OutflowOfferMobileProps, OutflowOfferWebProps } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers.types';
import type { Reasons } from 'reactApp/ui/PollPopup/PollPopup.constants';
import { closePollPopup, renderPollPopup } from 'reactApp/ui/PollPopup/PollPopup.helpers';
import { select } from 'typed-redux-saga';

export function* surveyOffer({ continueOutflow, cancelOutflow, outflowContext }: OutflowOfferWebProps) {
    const isPhone = yield* select(EnvironmentSelectors.isPhone);
    yield renderPollPopup({
        isPhone,
        onClose() {
            closePollPopup();
            cancelOutflow();
        },
        onSubmit(choice) {
            outflowContext.choice = choice as Reasons;
            closePollPopup();
            continueOutflow();
        },
    });
}

export function* surveyOfferMobile(props: OutflowOfferMobileProps) {
    yield surveyOffer(props);
}
